
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Layer 1","viewBox":"0 0 100 125"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50 11a12.92 12.92 0 00-12.9 12.9v26.41a12.9 12.9 0 0025.8 0V23.9A12.92 12.92 0 0050 11z"}}),_c('path',{attrs:{"d":"M53.64 77.24V89h-7.28V77.24c-13-1.53-23.14-11.14-23.14-22.76h7.27c0 8.67 8.75 15.72 19.51 15.72s19.51-7.05 19.51-15.72h7.27c0 11.62-10.09 21.23-23.14 22.76z"}})])
          )
        }
      }
    